import store from '../store/store';
import notificationAction from '../actions/notificationAction';
import { AlertSeverity, Alert } from '../interfaces/global-interfaces';



export default function openNotification(msg: string, severity: AlertSeverity){
    store.dispatch(notificationAction(Alert.Open, msg, severity));
}